import {
  Box,
  Button,
  TextField,
  IconButton,
  InputAdornment,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCategoria from "../../modal/categoria/modalCategoria";
import ModalProducto from "../../modal/producto/modalProveedorProducto";
import ModalPvb from "../../modal/pvb/modalPvbEspesura";

import { PostDatosProductos } from "../../services/productos.services";
import ModalProveedor from "../../modal/proveedor/modalProveedor";


const Productos = () => {
  const [proveedor, setProveedor] = useState("");
  const [serviceType, setServiceType] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [clasificacionModalOpen, setClasificacionModalOpen] = useState(false);
  const [proveedorModalOpen, setProveedorModalOpen] = useState(false);
  const [pvbModalOpen, setPvbModalOpen] = useState(false);
  const [modalProductoOpen, setModalProductoOpen] = useState(false);
  const [activeChapaField, setActiveChapaField] = useState(null);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { codi, descripcion, id_categoria, medidas, id_proveedor, codigo, precio, pvb } = values;

    const isCategoriaChapa = Number(id_categoria) === 2;

    const valuesToSend = {
      // ...values,
      cod: codi,
      id_proveedor,
      id_pvb: isCategoriaChapa ? (pvb || null) : null,
      codigo,
      descripcion,
      id_categoria,
      medidas,
      tipo: values.reflectivo ? "LADO REFLECTIVO" : null,
      llave: isCategoriaChapa && values.llave ? 1 : 0,
      chapa1: isCategoriaChapa ? values.chapa1 : " ",
      chapa2: isCategoriaChapa ? values.chapa2 : " ",
      precio: Number(precio) || 0,
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      
      const response = await PostDatosProductos(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSelectProveedor = (proveedor, setFieldValue) => {
    setFieldValue("id_proveedor", proveedor.id);
    setFieldValue("proveedor", proveedor.nombre);
    setProveedor(proveedor.id)

    setProveedorModalOpen(false); // Cerrar el modal de productos
  };

  const handleSelectPvb = (pvb, setFieldValue) => {
    setFieldValue("id_pvb", pvb.cod || "");
    setFieldValue("pvb", pvb.cod || "");
    setPvbModalOpen(false);
  };

  const handleOpenProductoModal = (field) => {
    setActiveChapaField(field);
    setModalProductoOpen(true);
  };

  const handleCloseProductoModal = () => {
    setModalProductoOpen(false);
    setActiveChapaField(null);
  };

    useEffect(() => {
      setServiceType(proveedor);
    }, [proveedor]);
  return (
    <Box m="20px">
      <Header title="Registro Productos" subtitle="Registro Productos" />

      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          id_proveedor: "",
          id_pvb: "",
          codigo: "",
          codi: "",
          descripcion: "",
          id_categoria: "",
          medidas: "",
          reflectivo: false,
          llave: false,
          chapa1: "",
          chapa2: "",
          proveedor: "",
          pvb: "",
          precio: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => {
          const parseChapa = (chapa) => {
            if (!chapa) {
              return null;
            }

            const chapaMatch = chapa.match(/^([A-Za-z]+)-([A-Za-z]+)(\d+)mm([0-9]+x[0-9]+)$/);

            if (!chapaMatch) {
              return null;
            }

            return {
              prefix: chapaMatch[1],
              code: chapaMatch[2],
              thickness: chapaMatch[3],
              measure: chapaMatch[4],
            };
          };

          const buildCombinedCodigo = (chapa1Value, chapa2Value) => {
            const parsedChapa1 = parseChapa(chapa1Value);
            const parsedChapa2 = parseChapa(chapa2Value);

            if (!parsedChapa1 || !parsedChapa2) {
              return [chapa1Value, chapa2Value].filter(Boolean).join("+");
            }

            const { prefix: prefix1, code: code1, thickness: thickness1, measure: measure1 } = parsedChapa1;
            const { prefix: prefix2, code: code2, thickness: thickness2, measure: measure2 } = parsedChapa2;

            const prefix = prefix1 === prefix2 ? prefix1 : `${prefix1}/${prefix2}`;
            const trimmedThickness1 = thickness1.length > 1 ? thickness1.slice(0, -1) : "";
            const trimmedThickness2 = thickness2.length > 1 ? thickness2.slice(0, -1) : "";
            const basePart1 = `${prefix}-${code1}${trimmedThickness1}`;
            const basePart2 = `${code2}${trimmedThickness2}`;
            const thicknessSection = `${thickness1.slice(-1)}1${thickness2.slice(-1)}`;
            const measurementsMatch = measure1 === measure2;
            const measurementSection = measurementsMatch ? measure1 : `${measure1}|${measure2}`;

            return `${basePart1}+${basePart2}${thicknessSection} ${measurementSection}`;
          };

          const buildCodigoWithPvb = (baseCodigo, pvbCodigo) => {
            if (!pvbCodigo) {
              return baseCodigo;
            }

            if (!baseCodigo) {
              return pvbCodigo;
            }

            return `${baseCodigo}-${pvbCodigo}`;
          };

          const combineChapasIntoCodigo = (nextValue, fieldName, pvbCodigoOverride = null) => {
            const chapa1Value = fieldName === "chapa1" ? nextValue : values.chapa1;
            const chapa2Value = fieldName === "chapa2" ? nextValue : values.chapa2;
            const pvbCodigo = pvbCodigoOverride ?? values.id_pvb;

            if (!chapa1Value && !chapa2Value) {
              setFieldValue("codi", buildCodigoWithPvb("", pvbCodigo));
              return;
            }

            if (!chapa1Value || !chapa2Value) {
              const singleValue = chapa1Value || chapa2Value || "";
              setFieldValue("codi", buildCodigoWithPvb(singleValue, pvbCodigo));
              return;
            }

            const combinedCodigo = buildCombinedCodigo(chapa1Value, chapa2Value);
            setFieldValue("codi", buildCodigoWithPvb(combinedCodigo, pvbCodigo));
          };

          return (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Proveedor"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.proveedor || ""}
                name="id_proveedor"
                error={!!touched.id_proveedor && !!errors.id_proveedor}
                helperText={touched.id_proveedor && errors.id_proveedor}
                sx={{ gridColumn: "span 1" }}
                onClick={() => setProveedorModalOpen(true)}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Categoria"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.id_categoria || ""}
                name="id_categoria"
                error={!!touched.id_categoria && !!errors.id_categoria}
                helperText={touched.id_categoria && errors.id_categoria}
                sx={{ gridColumn: "span 1" }}
                onClick={() => setClasificacionModalOpen(true)}
              />
              {Number(values.id_categoria) === 2 && (
                <>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Chapa 1"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.chapa1 || ""}
                    name="chapa1"
                    error={!!touched.chapa1 && !!errors.chapa1}
                    helperText={touched.chapa1 && errors.chapa1}
                    sx={{ gridColumn: "span 1" }}
                    InputProps={{
                      readOnly: true,
                    }}
                    onClick={() => handleOpenProductoModal("chapa1")}

                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Chapa 2"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.chapa2 || ""}
                    name="chapa2"
                    error={!!touched.chapa2 && !!errors.chapa2}
                    helperText={touched.chapa2 && errors.chapa2}
                    sx={{ gridColumn: "span 1" }}
                    InputProps={{
                      readOnly: true,
                    }}
                    onClick={() => handleOpenProductoModal("chapa2")}

                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="PVB"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.pvb || ""}
                    name="pvb"
                    error={!!touched.id_pvb && !!errors.id_pvb}
                    helperText={touched.id_pvb && errors.id_pvb}
                    sx={{ gridColumn: "span 1" }}
                    InputProps={{
                      readOnly: true,
                    }}
                    onClick={() => setPvbModalOpen(true)}
                  />
                </>
              )}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Codigo"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.codi || ""}
                name="codi"
                error={!!touched.codi && !!errors.codi}
                helperText={touched.codi && errors.codi}
                sx={{ gridColumn: "span 2" }}
              />
              {Number(values.id_categoria) === 2 && (
                <Box sx={{ gridColumn: "span 1" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="secondary"
                        checked={values.llave}
                        onChange={(event) =>
                          setFieldValue("llave", event.target.checked)
                        }
                      />
                    }
                    label="Llave"
                  />
                </Box>
              )}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Alias"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.codigo || ""}
                name="codigo"
                error={!!touched.codigo && !!errors.codigo}
                helperText={touched.codigo && errors.codigo}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Descripcion"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.descripcion || ""}
                name="descripcion"
                error={!!touched.descripcion && !!errors.descripcion}
                helperText={touched.descripcion && errors.descripcion}
                sx={{ gridColumn: "span 2" }}
              />
              
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Medidas"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.medidas || ""}
                name="medidas"
                error={!!touched.medidas && !!errors.medidas}
                helperText={touched.medidas && errors.medidas}
                sx={{ gridColumn: "span 1" }}
              />

              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Precio"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.precio || ""}
                name="precio"
                error={!!touched.precio && !!errors.precio}
                helperText={touched.precio && errors.precio}
                sx={{ gridColumn: "span 1" }}
                inputProps={{ min: 0, step: "0.01" }}
              />



              <Box sx={{ gridColumn: "span 1" }}>
                <FormControlLabel
                  control={
                    <Switch
                      color="secondary"
                      checked={values.reflectivo}
                      onChange={(event) =>
                        setFieldValue("reflectivo", event.target.checked)
                      }
                    />
                  }
                  label="Reflectivo"
                />
              </Box>
              {/* Otros campos */}
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Crear Producto
              </Button>
            </Box>

            <ModalCategoria
              open={clasificacionModalOpen}
              onClose={() => setClasificacionModalOpen(false)}
              onSelect={(field) => {
                setFieldValue("id_categoria", field.id);
                if (Number(field.id) !== 2) {
                  setFieldValue("id_pvb", "");
                  setFieldValue("pvb", "");
                  setFieldValue("llave", false);
                }
              }} // Usa onSelect aquí y asegúrate de acceder al campo "id"
            />

            <ModalProveedor
              open={proveedorModalOpen} // Estado del modal de proveedors
              onClose={() => setProveedorModalOpen(false)} // Cerrar el modal de Proveedors
              onSelect={(proveedor) =>
                handleSelectProveedor(proveedor, setFieldValue)
              } 
            />
            <ModalPvb
              open={pvbModalOpen}
              onClose={() => setPvbModalOpen(false)}
              onSelect={(pvb) => {
                const pvbCodigo = pvb.cod || "";
                handleSelectPvb(pvb, setFieldValue);
                combineChapasIntoCodigo(values.chapa2, "chapa2", pvbCodigo);
              }}
            />
            <ModalProducto
              open={modalProductoOpen}
              onClose={handleCloseProductoModal}
              serviceType={serviceType}

              onSelectProduct={(producto) => {
                if (activeChapaField) {
                  setFieldValue(activeChapaField, producto.cod);
                  combineChapasIntoCodigo(producto.cod, activeChapaField);
                }
                handleCloseProductoModal();
              }}
            />

          </form>
          );
        }}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  id_proveedor: yup.string().required("Proveedor del Producto requerido"),
  id_pvb: yup
    .string()
    .when("id_categoria", {
      is: (value) => Number(value) === 2,
      then: (schema) => schema.required("PVB requerido"),
      otherwise: (schema) => schema.notRequired(),
    }),
  codigo: yup.string().required("Alias del Producto requerido"),
  codi: yup.string().required("Codigo del Producto requerida"),
  descripcion: yup.string().required("Descripción del Producto requerida"),
  id_categoria: yup.number().required("Categoria requerida"), // Agrega validación si es necesario
  medidas: yup.string().required("Medidas requerida"),
  precio: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .typeError("Precio inválido")
    .positive("Precio debe ser mayor a cero")
    .required("Precio requerido"),
  reflectivo: yup.boolean(),
  llave: yup.boolean(),
  chapa1: yup
    .string()
    .when("id_categoria", {
      is: (value) => Number(value) === 2,
      then: (schema) => schema.required("Chapa 1 requerida"),
      otherwise: (schema) => schema.notRequired(),
    }),
  chapa2: yup
    .string()
    .when("id_categoria", {
      is: (value) => Number(value) === 2,
      then: (schema) => schema.required("Chapa 2 requerida"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default Productos;